<template>
  <div>
    <div class="center_col_container hidden-md-and-up">
      <el-alert
          title="本网站为电脑网站，使用竖屏查看可能会使UI显示较为奇怪。请使用电脑或Ipad打开本网页，或横屏查看。"
          type="warning"
          effect="dark">
      </el-alert>
      <el-menu
          default-active="1"
          class="el-menu-vertical-demo"
          mode="horizontal"
          @select="handleSelect">
        <el-submenu index="11">
          <template slot="title">
            <i class="el-icon-data-analysis"></i>
            <span>我的课程</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="1">
              <i class="el-icon-menu"></i>
              <span slot="title">我的排课</span>
            </el-menu-item>
            <el-menu-item index="lesson_finished">
              <i class="el-icon-finished"></i>
              <span slot="title">已完成</span>
            </el-menu-item>
            <el-menu-item index="3">
              <i class="el-icon-document"></i>
              <span slot="title">课程合集</span>
            </el-menu-item>
            <el-menu-item index="class">
              <i class="el-icon-takeaway-box"></i>
              <span slot="title">我的班课</span>
            </el-menu-item>
            <el-menu-item index="kc">
              <i class="el-icon-postcard"></i>
              <span slot="title">下载课程表</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item index="2">
          <i class="el-icon-s-custom"></i>
          <span slot="title">我的老师</span>
        </el-menu-item>
        <el-menu-item index="4">
          <i class="el-icon-setting"></i>
          <span slot="title">个人信息</span>
        </el-menu-item>
        <el-menu-item index="tutorial">
          <i class="el-icon-reading"></i>
          <span slot="title">使用教程</span>
        </el-menu-item>
      </el-menu>
      <el-dialog title="课程时间确认" :visible.sync="orderTimeDialogVisible"
                 width="90%"
      >
        <div class="flex_start_col_container" v-loading="dialog_loading">
        <span style="font-size: 16px;padding: 10px">是否确认<b>{{
            confirm_lesson_info.teacher_name
          }}</b>的 {{ confirm_lesson_info.subject }}课程时间为
<b>当地时间{{ confirm_lesson_info.start_time }}-{{
    confirm_lesson_info.finish_time
  }}</b>(日期：{{ confirm_lesson_info.start_date }})？</span>
          <span style="font-size: 13px;padding: 10px;color: dimgray">（后期仍可调配时间）</span>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="disconfirmLessonTime(confirm_lesson_info.id)">这个时间不太行</el-button>
        <el-button type="primary" @click="confirmLessonTime(confirm_lesson_info.id)">该时间可行</el-button>
      </span>
      </el-dialog>
      <el-dialog title="提示" :visible.sync="lessonInfoDialogVisible"
                 width="90%"
      >
        <div class="flex_start_col_container" v-loading="dialog_loading">
          <span style="font-size: 18px;padding: 10px">课程信息：</span>
          <template v-if="check_lesson_info.notice_info!==''">
        <span style="font-size: 14px;padding: 10px" class="clickable_item"
              @click="copyToClip(check_lesson_info.notice_info)"
              v-html="getBrText(check_lesson_info.notice_info)">
        </span>
          </template>
          <template v-else>
        <span style="font-size: 16px;padding: 10px">
          暂无任何信息，等待老师补充中...
        </span>
          </template>
          <template v-if="check_lesson_info.additional_info!==''">
            <span style="font-size: 18px;padding: 10px;margin-top: 20px;font-weight: 500">额外信息：</span>
            <span style="font-size: 14px;padding: 10px;" class="clickable_item"
                  v-html="getBrText(check_lesson_info.additional_info)"
                  @click="copyToClip(check_lesson_info.additional_info)">
        </span>
          </template>
          <span style="color: #8c939d;font-size: 14px;padding: 10px;margin-top: 10px">（点击文字复制课程信息）</span>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="warning" v-if="check_lesson_info.notice_info===''&&check_lesson_info.lesson_type!=='class'"
                   @click="noticeTeacherProvideInfo(check_lesson_info.id)">提醒老师提供上课信息</el-button>
        <el-button type="primary" @click="lessonInfoDialogVisible=false">好的</el-button>
      </span>
      </el-dialog>
      <el-dialog title="课程时间约定设置" :visible.sync="timeSettingDialogVisible"
                 width="90%">
        <div class="flex_start_col_container" v-loading="dialog_loading">
          <TimePicker @submit="timeSettingSubmit" :duration="time_setting_lesson_duration"/>
        </div>
      </el-dialog>
      <el-dialog title="课程预约" :visible.sync="orderLessonDialogVisible"
                 width="90%">
        <div class="flex_start_col_container" v-loading="dialog_loading">
          <LessonOrdering :com="order_lesson_combination" @submit="orderLessonSubmit"/>
        </div>
      </el-dialog>
      <el-dialog title="评分反馈" :visible.sync="feedbackEnterDialogVisible"
                 width="90%">
        <div class="flex_start_col_container" v-loading="dialog_loading">
          <span style="padding: 10px;padding-left:0px;font-size: 16px">老师本次课程评分：</span>
          <el-rate
              v-model="lesson_rating"
              show-text>
          </el-rate>
          <span style="padding: 10px;padding-left:0px;font-size: 16px">课堂反馈信息：</span>
          <el-input type="textarea" :rows="5"
                    :autosize="{ minRows: 4}" v-model="lesson_feedback"
                    placeholder="如上课可以讲的慢一些/什么地方没有太听懂等"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="feedbackSubmit">提交</el-button>
      </span>
      </el-dialog>
      <el-dialog title="老师反馈" :visible.sync="feedbackDisplayDialogVisible"
                 width="90%">
        <div class="flex_start_col_container" v-loading="dialog_loading">
          <span style="padding: 10px;padding-left:0px;font-size: 16px">课堂反馈信息：</span>
          <span style="font-size: 14px;padding: 10px"
                v-html="getBrText(display_feedback)">
        </span>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="feedbackDisplayDialogVisible=false">好的</el-button>
      </span>
      </el-dialog>
      <el-dialog title="课程时间约定设置" :visible.sync="timeSettingDialogVisible"
                 width="90%">
        <div class="flex_start_col_container" v-loading="dialog_loading">
          <TimePicker @submit="timeSettingSubmit" :duration="time_setting_lesson_duration"/>
        </div>
      </el-dialog>
      <el-dialog title="学生端教程" :visible.sync="tutorialDisplayDialogVisible"
                 width="90%">
        <div class="flex_start_col_container" v-loading="dialog_loading">
          <iframe class="hover_shadow hidden-md-and-up" style="height: 300px;width:100%"
                  src="https://easytutor.zqwei-tech.cn/video/学生.mp4" v-if="tutorialDisplayDialogVisible"
                  scrolling="yes" border="0" frameborder="no" framespacing="1" allowfullscreen="true"></iframe>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tutorialDisplayDialogVisible=false">好的</el-button>
      </span>
      </el-dialog>
      <el-row type="flex" :gutter="5" class="row-bg" justify="space-around" v-loading="loading">

        <el-col :span="24">
          <!--      <template></template>-->
          <!--      <el-calendar v-if="this.display_index==='5'">-->
          <!--      <el-calendar v-if="this.display_index==='5'">-->
          <!--        &lt;!&ndash; 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法&ndash;&gt;-->
          <!--        <template-->
          <!--            slot="dateCell"-->
          <!--            slot-scope="{date, data}">-->
          <!--          <div class="flex_end_col_container" style="padding: 2px">-->
          <!--            {{ date.getDate() }}-->
          <!--            <template v-if="data.day==='2021-09-21'">-->
          <!--              <div class="flex_start_col_container" style="padding: 4px;background-color: #50b9ce ;width: 100%">-->
          <!--                <span style="font-size: 10px;color: white">19:00 物理课 Jimmy老师</span>-->
          <!--              </div>-->
          <!--              <div class="flex_start_col_container" style="padding: 4px;background-color: #409EFF;width: 100%">-->
          <!--                <span style="font-size: 10px;color: white">查看更多</span>-->
          <!--              </div>-->

          <!--            </template>-->
          <!--          </div>-->
          <!--        </template>-->
          <!--      </el-calendar>-->
          <el-table
              :data="info.lessons"
              stripe
              height="500"
              style="width: 100%"
              v-if="this.display_index==='1'">
            <el-table-column
                label="日期">
              <template slot-scope="scope">
                <i class="el-icon-time"></i>
                <span style="margin-left: 10px">{{ scope.row.start_date }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="subject"
                label="课程">
            </el-table-column>
            <el-table-column
                prop="teacher_name"
                label="老师">
            </el-table-column>
            <el-table-column
                label="时间">
              <template slot-scope="scope">
                <i class="el-icon-time"></i>
                <span style="margin-left: 10px">{{ scope.row.start_time }}开始
            <template v-if="scope.row.status==='reorder'">（重新约定中）</template></span>
              </template>
            </el-table-column>
            <el-table-column
                label="课程时长">
              <template slot-scope="scope">
                <i class="el-icon-connection"></i>
                <span style="margin-left: 10px">{{ scope.row.duration_hour }}小时</span>
              </template>
            </el-table-column>
            <el-table-column
                label="状态">
              <template slot-scope="scope">
                <div class="flex_start_col_container">
              <span v-if="scope.row.has_student_paid">
                {{ getDisplayStatus(scope.row.status) }}
              </span>
                  <span v-else>
                <i class="el-icon-time"></i>
                等待付款
              </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                label="操作">
              <template slot-scope="scope">
                <template v-if="scope.row.lesson_type==='class'">
                  <el-button type="warning" plain round @click="checkLessonInfo(scope.row)">班课信息</el-button>
                </template>
                <template v-else-if="scope.row.has_student_paid">
                  <template v-if="scope.row.status==='ordering'">
                    <el-button v-if="!scope.row.has_student_verified" @click="orderTimeComfirm(scope.row)" type="primary"
                               plain
                               round>约课确认
                    </el-button>
                    <el-button v-if="scope.row.has_student_verified" :disabled="true" type="primary" round>待老师确认</el-button>
                  </template>
                  <template v-else-if="scope.row.status==='reorder'">
                    <el-button type="info" round disabled v-if="scope.row.verify_master!=='student'">重约处理中</el-button>
                    <el-button type="danger" round v-else @click="timeSettingUpdate(scope.row)">重约时间</el-button>
                  </template>
                  <template v-else>
                    <el-button type="success" plain round @click="checkLessonInfo(scope.row)">上课信息</el-button>
                  </template>
                </template>
                <template v-else>
                  <el-button @click="payForSingleLesson(scope.row.id)" type="primary" round>立即支付</el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <el-table
              :data="info.f_lessons"
              stripe
              height="500"
              style="width: 100%"
              v-if="this.display_index==='lesson_finished'">
            <el-table-column
                label="日期">
              <template slot-scope="scope">
                <i class="el-icon-time"></i>
                <span style="margin-left: 10px">{{ scope.row.start_date }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="subject"
                label="课程">
            </el-table-column>
            <el-table-column
                prop="teacher_name"
                label="老师">
            </el-table-column>
            <el-table-column
                label="时间">
              <template slot-scope="scope">
                <i class="el-icon-time"></i>
                <span style="margin-left: 10px">{{ scope.row.start_time }}开始
            <template v-if="scope.row.status==='reorder'">（重新约定中）</template></span>
              </template>
            </el-table-column>
            <el-table-column
                label="课程时长">
              <template slot-scope="scope">
                <i class="el-icon-connection"></i>
                <span style="margin-left: 10px">{{ scope.row.duration_hour }}小时</span>
              </template>
            </el-table-column>
            <el-table-column
                label="状态">
              <template slot-scope="scope">
                <div class="flex_start_col_container">
              <span v-if="scope.row.has_student_paid">
                {{ getDisplayStatus(scope.row.status) }}
              </span>
                  <span v-else>
                <i class="el-icon-time"></i>
                等待付款
              </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                label="反馈">
              <template slot-scope="scope">
                <template v-if="scope.row.student_feedback||scope.row.lesson_type==='class'">
                  <el-button v-if="scope.row.teacher_feedback" type="primary" round
                             @click="feedbackDisplayDialogVisible=true;display_feedback=scope.row.teacher_feedback">查看老师反馈
                  </el-button>
                  <el-button v-else type="primary" disabled round>等待老师反馈</el-button>
                </template>
                <template v-else>
                  <el-button round type="danger" @click="feedbackDialogDisplay(scope.row.id)">评分与反馈</el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <el-table
              :data="info.combinations"
              stripe
              height="500"
              style="width: 100%"
              v-if="this.display_index==='2'">

            <el-table-column
                label="老师">
              <template slot-scope="scope">
                <i class="el-icon-user"></i>
                <span style="margin-left: 5px">{{ scope.row.teacher_name }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="课程">
              <template slot-scope="scope">
                <i class="el-icon-office-building"></i>
                <span style="margin-left: 5px">{{ scope.row.subject }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="学费/小时">
              <template slot-scope="scope">
                <span>￥{{ scope.row.hour_student_fee }}/小时</span>
              </template>
            </el-table-column>

            <el-table-column
                label="老师信息">
              <template slot-scope="scope">
                <el-button @click="goToTeacherDetail(scope.row.teacher.id)" round type="primary">查看详情</el-button>
              </template>
            </el-table-column>

            <el-table-column
                label=课程操作>
              <template slot-scope="scope">
                <el-button @click="orderNewLesson(scope.row)" round type="danger">预约独立新课</el-button>
              </template>
            </el-table-column>

          </el-table>
          <el-table
              :data="info.lessonsets"
              stripe
              height="500"
              style="width: 100%"
              v-if="this.display_index==='3'">
            <el-table-column
                label="老师">
              <template slot-scope="scope">
                <i class="el-icon-user"></i>
                <span style="margin-left: 5px">{{ info.combination_dict[scope.row.combination].teacher.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="课程">
              <template slot-scope="scope">
                <i class="el-icon-office-building"></i>
                <span style="margin-left: 5px"> {{ info.combination_dict[scope.row.combination].subject }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="总课时"
            >
              <template slot-scope="scope">
                {{ scope.row.total_hours }}小时
              </template>
            </el-table-column>
            <el-table-column
                label="剩余课时"
            >
              <template slot-scope="scope">
                {{ scope.row.remaining_hours }}小时
              </template>
            </el-table-column>

            <el-table-column
                label="未计划课时"
            >
              <template slot-scope="scope">
                {{ scope.row.remaining_unplanned_hours }}小时
              </template>
            </el-table-column>
            <el-table-column
                label="合集状态"
            >
              <template slot-scope="scope">
                <template v-if="!scope.row.has_student_paid">
                  等待付款
                </template>
                <template v-else-if="scope.row.has_student_paid&&scope.row.has_finished">
                  已结课
                </template>
                <template v-else-if="scope.row.has_student_paid&&!scope.row.has_finished">
                  上课中（未结课）
                </template>
              </template>
            </el-table-column>
            <el-table-column
                label=课程操作>
              <template slot-scope="scope">
                <el-button v-if="scope.row.remaining_unplanned_hours!==0" @click="orderNewLessonFromSet(scope.row)" round
                           type="primary">预约新课
                </el-button>
                <el-button v-else disabled round type="primary">无可用课时</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-table
              :data="info.class_sets"
              stripe
              height="500"
              style="width: 100%"
              v-if="this.display_index==='class'">
            <el-table-column
                label="老师">
              <template slot-scope="scope">
                <i class="el-icon-user"></i>
                <span style="margin-left: 5px">{{ scope.row.teacher_name }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="课程">
              <template slot-scope="scope">
                <i class="el-icon-office-building"></i>
                <span style="margin-left: 5px"> {{ scope.row.subject }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="总课时"
            >
              <template slot-scope="scope">
                {{ scope.row.total_hours }}小时
              </template>
            </el-table-column>
            <el-table-column
                label="剩余课时"
            >
              <template slot-scope="scope">
                {{ scope.row.remaining_hours }}小时
              </template>
            </el-table-column>

            <el-table-column
                label="未计划课时"
            >
              <template slot-scope="scope">
                {{ scope.row.remaining_unplanned_hours }}小时
              </template>
            </el-table-column>
            <el-table-column
                label="合集状态"
            >
              <template slot-scope="scope">
                <template v-if="scope.row.has_finished">
                  已结课
                </template>
                <template v-else>
                  上课中（未结课）
                </template>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="display_index==='4'" class="center_col_container" style="padding: 20px">
            <UserInfo :user="info.user" @change_pass="changePass"/>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row type="flex" :gutter="5" class="row-bg hidden-sm-and-down" justify="space-around" v-loading="loading">
      <el-dialog title="课程时间确认" :visible.sync="orderTimeDialogVisible"
                 width="30%"
      >
        <div class="flex_start_col_container" v-loading="dialog_loading">
        <span style="font-size: 16px;padding: 10px">是否确认<b>{{
            confirm_lesson_info.teacher_name
          }}</b>的 {{ confirm_lesson_info.subject }}课程时间为
<b>当地时间{{ confirm_lesson_info.start_time }}-{{
    confirm_lesson_info.finish_time
  }}</b>(日期：{{ confirm_lesson_info.start_date }})？</span>
          <span style="font-size: 13px;padding: 10px;color: dimgray">（后期仍可调配时间）</span>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="disconfirmLessonTime(confirm_lesson_info.id)">这个时间不太行</el-button>
        <el-button type="primary" @click="confirmLessonTime(confirm_lesson_info.id)">该时间可行</el-button>
      </span>
      </el-dialog>
      <el-dialog title="提示" :visible.sync="lessonInfoDialogVisible"
                 width="30%"
      >
        <div class="flex_start_col_container" v-loading="dialog_loading">
          <span style="font-size: 18px;padding: 10px">课程信息：</span>
          <template v-if="check_lesson_info.notice_info!==''">
        <span style="font-size: 14px;padding: 10px" class="clickable_item"
              @click="copyToClip(check_lesson_info.notice_info)"
              v-html="getBrText(check_lesson_info.notice_info)">
        </span>
          </template>
          <template v-else>
        <span style="font-size: 16px;padding: 10px">
          暂无任何信息，等待老师补充中...
        </span>
          </template>
          <template v-if="check_lesson_info.additional_info!==''">
            <span style="font-size: 18px;padding: 10px;margin-top: 20px;font-weight: 500">额外信息：</span>
            <span style="font-size: 14px;padding: 10px;" class="clickable_item"
                  v-html="getBrText(check_lesson_info.additional_info)"
                  @click="copyToClip(check_lesson_info.additional_info)">
        </span>
          </template>
          <span style="color: #8c939d;font-size: 14px;padding: 10px;margin-top: 10px">（点击文字复制课程信息）</span>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="warning" v-if="check_lesson_info.notice_info===''&&check_lesson_info.lesson_type!=='class'"
                   @click="noticeTeacherProvideInfo(check_lesson_info.id)">提醒老师提供上课信息</el-button>
        <el-button type="primary" @click="lessonInfoDialogVisible=false">好的</el-button>
      </span>
      </el-dialog>
      <el-dialog title="课程时间约定设置" :visible.sync="timeSettingDialogVisible"
                 width="30%">
        <div class="flex_start_col_container" v-loading="dialog_loading">
          <TimePicker @submit="timeSettingSubmit" :duration="time_setting_lesson_duration"/>
        </div>
      </el-dialog>

      <el-dialog title="课程预约" :visible.sync="orderLessonDialogVisible"
                 width="30%">
        <div class="flex_start_col_container" v-loading="dialog_loading">
          <LessonOrdering :com="order_lesson_combination" @submit="orderLessonSubmit"/>
        </div>
      </el-dialog>
      <el-dialog title="评分反馈" :visible.sync="feedbackEnterDialogVisible"
                 width="30%">
        <div class="flex_start_col_container" v-loading="dialog_loading">
          <span style="padding: 10px;padding-left:0px;font-size: 16px">老师本次课程评分：</span>
          <el-rate
              v-model="lesson_rating"
              show-text>
          </el-rate>
          <span style="padding: 10px;padding-left:0px;font-size: 16px">课堂反馈信息：</span>
          <el-input type="textarea" :rows="5"
                    :autosize="{ minRows: 4}" v-model="lesson_feedback"
                    placeholder="如上课可以讲的慢一些/什么地方没有太听懂等"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="feedbackSubmit">提交</el-button>
      </span>
      </el-dialog>
      <el-dialog title="老师反馈" :visible.sync="feedbackDisplayDialogVisible"
                 width="30%">
        <div class="flex_start_col_container" v-loading="dialog_loading">
          <span style="padding: 10px;padding-left:0px;font-size: 16px">课堂反馈信息：</span>
          <span style="font-size: 14px;padding: 10px"
                v-html="getBrText(display_feedback)">
        </span>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="feedbackDisplayDialogVisible=false">好的</el-button>
      </span>
      </el-dialog>
      <el-dialog title="课程时间约定设置" :visible.sync="timeSettingDialogVisible"
                 width="30%">
        <div class="flex_start_col_container" v-loading="dialog_loading">
          <TimePicker @submit="timeSettingSubmit" :duration="time_setting_lesson_duration"/>
        </div>
      </el-dialog>

      <el-dialog title="学生端教程" :visible.sync="tutorialDisplayDialogVisible"
                 width="850px">
        <div class="flex_start_col_container" v-loading="dialog_loading">
          <iframe class="hover_shadow hidden-sm-and-down" style="height: 500px;width:100%"
                  src="https://easytutor.zqwei-tech.cn/video/学生.mp4" v-if="tutorialDisplayDialogVisible"
                  scrolling="yes" border="0" frameborder="no" framespacing="1" allowfullscreen="true"></iframe>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tutorialDisplayDialogVisible=false">好的</el-button>
      </span>
      </el-dialog>
      <el-col :span="4">
        <el-menu
            default-active="1"
            class="el-menu-vertical-demo"
            @select="handleSelect">
          <el-submenu index="11">
            <template slot="title">
              <i class="el-icon-data-analysis"></i>
              <span>我的课程</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="1">
                <i class="el-icon-menu"></i>
                <span slot="title">我的排课</span>
              </el-menu-item>
              <el-menu-item index="lesson_finished">
                <i class="el-icon-finished"></i>
                <span slot="title">已完成</span>
              </el-menu-item>
              <el-menu-item index="3">
                <i class="el-icon-document"></i>
                <span slot="title">课程合集</span>
              </el-menu-item>
              <el-menu-item index="class">
                <i class="el-icon-takeaway-box"></i>
                <span slot="title">我的班课</span>
              </el-menu-item>
              <el-menu-item index="kc">
                <i class="el-icon-postcard"></i>
                <span slot="title">下载课程表</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="2">
            <i class="el-icon-s-custom"></i>
            <span slot="title">我的老师</span>
          </el-menu-item>
          <el-menu-item index="4">
            <i class="el-icon-setting"></i>
            <span slot="title">个人信息</span>
          </el-menu-item>
          <el-menu-item index="tutorial">
            <i class="el-icon-reading"></i>
            <span slot="title">使用教程</span>
          </el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="19">
        <!--      <template></template>-->
        <!--      <el-calendar v-if="this.display_index==='5'">-->
        <!--        &lt;!&ndash; 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法&ndash;&gt;-->
        <!--        <template-->
        <!--            slot="dateCell"-->
        <!--            slot-scope="{date, data}">-->
        <!--          <div class="flex_end_col_container" style="padding: 2px">-->
        <!--            {{ date.getDate() }}-->
        <!--            <template v-if="data.day==='2021-09-21'">-->
        <!--              <div class="flex_start_col_container" style="padding: 4px;background-color: #50b9ce ;width: 100%">-->
        <!--                <span style="font-size: 10px;color: white">19:00 物理课 Jimmy老师</span>-->
        <!--              </div>-->
        <!--              <div class="flex_start_col_container" style="padding: 4px;background-color: #409EFF;width: 100%">-->
        <!--                <span style="font-size: 10px;color: white">查看更多</span>-->
        <!--              </div>-->

        <!--            </template>-->
        <!--          </div>-->
        <!--        </template>-->
        <!--      </el-calendar>-->
        <el-table
            :data="info.lessons"
            stripe
            height="500"
            style="width: 100%"
            v-if="this.display_index==='1'">
          <el-table-column
              label="日期">
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ scope.row.start_date }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="subject"
              label="课程">
          </el-table-column>
          <el-table-column
              prop="teacher_name"
              label="老师">
          </el-table-column>
          <el-table-column
              label="时间">
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ scope.row.start_time }}开始
            <template v-if="scope.row.status==='reorder'">（重新约定中）</template></span>
            </template>
          </el-table-column>
          <el-table-column
              label="课程时长">
            <template slot-scope="scope">
              <i class="el-icon-connection"></i>
              <span style="margin-left: 10px">{{ scope.row.duration_hour }}小时</span>
            </template>
          </el-table-column>
          <el-table-column
              label="状态">
            <template slot-scope="scope">
              <div class="flex_start_col_container">
              <span v-if="scope.row.has_student_paid">
                {{ getDisplayStatus(scope.row.status) }}
              </span>
                <span v-else>
                <i class="el-icon-time"></i>
                等待付款
              </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="操作">
            <template slot-scope="scope">
              <template v-if="scope.row.lesson_type==='class'">
                <el-button type="warning" plain round @click="checkLessonInfo(scope.row)">班课信息</el-button>
              </template>
              <template v-else-if="scope.row.has_student_paid">
                <template v-if="scope.row.status==='ordering'">
                  <el-button v-if="!scope.row.has_student_verified" @click="orderTimeComfirm(scope.row)" type="primary"
                             plain
                             round>约课确认
                  </el-button>
                  <el-button v-if="scope.row.has_student_verified" :disabled="true" type="primary" round>待老师确认</el-button>
                </template>
                <template v-else-if="scope.row.status==='reorder'">
                  <el-button type="info" round disabled v-if="scope.row.verify_master!=='student'">重约处理中</el-button>
                  <el-button type="danger" round v-else @click="timeSettingUpdate(scope.row)">重约时间</el-button>
                </template>
                <template v-else>
                  <el-button type="success" plain round @click="checkLessonInfo(scope.row)">上课信息</el-button>
                </template>
              </template>
              <template v-else>
                <el-button @click="payForSingleLesson(scope.row.id)" type="primary" round>立即支付</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <el-table
            :data="info.f_lessons"
            stripe
            height="500"
            style="width: 100%"
            v-if="this.display_index==='lesson_finished'">
          <el-table-column
              label="日期">
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ scope.row.start_date }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="subject"
              label="课程">
          </el-table-column>
          <el-table-column
              prop="teacher_name"
              label="老师">
          </el-table-column>
          <el-table-column
              label="时间">
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ scope.row.start_time }}开始
            <template v-if="scope.row.status==='reorder'">（重新约定中）</template></span>
            </template>
          </el-table-column>
          <el-table-column
              label="课程时长">
            <template slot-scope="scope">
              <i class="el-icon-connection"></i>
              <span style="margin-left: 10px">{{ scope.row.duration_hour }}小时</span>
            </template>
          </el-table-column>
          <el-table-column
              label="状态">
            <template slot-scope="scope">
              <div class="flex_start_col_container">
              <span v-if="scope.row.has_student_paid">
                {{ getDisplayStatus(scope.row.status) }}
              </span>
                <span v-else>
                <i class="el-icon-time"></i>
                等待付款
              </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="反馈">
            <template slot-scope="scope">
              <template v-if="scope.row.student_feedback||scope.row.lesson_type==='class'">
                <el-button v-if="scope.row.teacher_feedback" type="primary" round
                           @click="feedbackDisplayDialogVisible=true;display_feedback=scope.row.teacher_feedback">查看老师反馈
                </el-button>
                <el-button v-else type="primary" disabled round>等待老师反馈</el-button>
              </template>
              <template v-else>
                <el-button round type="danger" @click="feedbackDialogDisplay(scope.row.id)">评分与反馈</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <el-table
            :data="info.combinations"
            stripe
            height="500"
            style="width: 100%"
            v-if="this.display_index==='2'">

          <el-table-column
              label="老师">
            <template slot-scope="scope">
              <i class="el-icon-user"></i>
              <span style="margin-left: 5px">{{ scope.row.teacher_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="课程">
            <template slot-scope="scope">
              <i class="el-icon-office-building"></i>
              <span style="margin-left: 5px">{{ scope.row.subject }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="学费/小时">
            <template slot-scope="scope">
              <span>￥{{ scope.row.hour_student_fee }}/小时</span>
            </template>
          </el-table-column>

          <el-table-column
              label="老师信息">
            <template slot-scope="scope">
              <el-button @click="goToTeacherDetail(scope.row.teacher.id)" round type="primary">查看详情</el-button>
            </template>
          </el-table-column>

          <el-table-column
              label=课程操作>
            <template slot-scope="scope">
              <el-button @click="orderNewLesson(scope.row)" round type="danger">预约独立新课</el-button>
            </template>
          </el-table-column>

        </el-table>
        <el-table
            :data="info.lessonsets"
            stripe
            height="500"
            style="width: 100%"
            v-if="this.display_index==='3'">
          <el-table-column
              label="老师">
            <template slot-scope="scope">
              <i class="el-icon-user"></i>
              <span style="margin-left: 5px">{{ info.combination_dict[scope.row.combination].teacher.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="课程">
            <template slot-scope="scope">
              <i class="el-icon-office-building"></i>
              <span style="margin-left: 5px"> {{ info.combination_dict[scope.row.combination].subject }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="总课时"
          >
            <template slot-scope="scope">
              {{ scope.row.total_hours }}小时
            </template>
          </el-table-column>
          <el-table-column
              label="剩余课时"
          >
            <template slot-scope="scope">
              {{ scope.row.remaining_hours }}小时
            </template>
          </el-table-column>

          <el-table-column
              label="未计划课时"
          >
            <template slot-scope="scope">
              {{ scope.row.remaining_unplanned_hours }}小时
            </template>
          </el-table-column>
          <el-table-column
              label="合集状态"
          >
            <template slot-scope="scope">
              <template v-if="!scope.row.has_student_paid">
                等待付款
              </template>
              <template v-else-if="scope.row.has_student_paid&&scope.row.has_finished">
                已结课
              </template>
              <template v-else-if="scope.row.has_student_paid&&!scope.row.has_finished">
                上课中（未结课）
              </template>
            </template>
          </el-table-column>
          <el-table-column
              label=课程操作>
            <template slot-scope="scope">
              <el-button v-if="scope.row.remaining_unplanned_hours!==0" @click="orderNewLessonFromSet(scope.row)" round
                         type="primary">预约新课
              </el-button>
              <el-button v-else disabled round type="primary">无可用课时</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-table
            :data="info.class_sets"
            stripe
            height="500"
            style="width: 100%"
            v-if="this.display_index==='class'">
          <el-table-column
              label="老师">
            <template slot-scope="scope">
              <i class="el-icon-user"></i>
              <span style="margin-left: 5px">{{ scope.row.teacher_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="课程">
            <template slot-scope="scope">
              <i class="el-icon-office-building"></i>
              <span style="margin-left: 5px"> {{ scope.row.subject }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="总课时"
          >
            <template slot-scope="scope">
              {{ scope.row.total_hours }}小时
            </template>
          </el-table-column>
          <el-table-column
              label="剩余课时"
          >
            <template slot-scope="scope">
              {{ scope.row.remaining_hours }}小时
            </template>
          </el-table-column>

          <el-table-column
              label="未计划课时"
          >
            <template slot-scope="scope">
              {{ scope.row.remaining_unplanned_hours }}小时
            </template>
          </el-table-column>
          <el-table-column
              label="合集状态"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.has_finished">
                已结课
              </template>
              <template v-else>
                上课中（未结课）
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="display_index==='4'" class="center_col_container" style="padding: 20px">
          <UserInfo :user="info.user" @change_pass="changePass"/>
        </div>
      </el-col>
    </el-row>
  </div>

</template>

<script>
import crypto_utils from "@/utils/crypto_utils";
import {randomString} from "@/utils/utils";
import {
  confirm_lesson_time, create_new_lesson,
  deconfirm_lesson_time, download_user_ics,
  get_user_center,
  notice_teacher_provide_info, reorder_lesson_time, submit_feedback
} from "@/utils/netschool_utils";

import {get_single_lesson_payment_url} from "@/utils/payment_utils";
import UserInfo from "@/components/UserInfo";
import TimePicker from "@/components/TimePicker";
import LessonOrdering from "@/components/LessonOrdering";

export default {
  name: "StudentCenter",
  components: {
    LessonOrdering,
    TimePicker,
    UserInfo,
    'full-calendar': require('vue-fullcalendar')
  },
  data() {
    return {
      orderTimeDialogVisible: false,
      lessonInfoDialogVisible: false,
      timeSettingDialogVisible: false,
      orderLessonDialogVisible: false,
      feedbackEnterDialogVisible: false,
      feedbackDisplayDialogVisible: false,
      tutorialDisplayDialogVisible: false,
      lesson_feedback: "",
      display_feedback: "",
      lesson_rating: 5,
      feedback_lesson_id: 0,
      time_setting_lesson_id: 0,
      time_setting_lesson_duration: 1,
      order_lesson_combination: {},
      order_lesson_set: null,
      lessons: [],
      combinations: [],
      display_index: "1",
      user: {},
      loading: false,
      dialog_loading: false,
      confirm_lesson_info: {},
      check_lesson_info: {
        lesson_type: ""
      },
      info: {},
    }
  },
  mounted() {
    // get_user_center(this)
    this.$EventBus.$on("student_user_center", (msg) => {
      this.info = msg
      this.loading = false
    });
  },
  methods: {
    feedbackSubmit() {
      submit_feedback(this.feedback_lesson_id, this.lesson_feedback, this, this.lesson_rating)
    },
    feedbackDialogDisplay(id) {
      this.feedback_lesson_id = id
      this.feedbackEnterDialogVisible = true
    },
    orderNewLesson(com) {
      this.order_lesson_combination = com
      this.orderLessonDialogVisible = true
      this.order_lesson_set = null
    },
    orderNewLessonFromSet(set) {
      this.order_lesson_combination = this.info.combination_dict[set.combination]
      this.orderLessonDialogVisible = true
      this.order_lesson_set = set
    },
    orderLessonSubmit(time, duration_hour) {
      if (this.order_lesson_set) {
        create_new_lesson(this.order_lesson_combination.id, (Date.parse(time) / 1000).toFixed(), duration_hour, this, this.order_lesson_set.id)
      } else {
        create_new_lesson(this.order_lesson_combination.id, (Date.parse(time) / 1000).toFixed(), duration_hour, this)
      }
    },
    timeSettingSubmit(time) {
      reorder_lesson_time(this.time_setting_lesson_id, (Date.parse(time) / 1000).toFixed(), this)
    },
    timeSettingUpdate(lesson) {
      this.time_setting_lesson_id = lesson.id
      this.time_setting_lesson_duration = lesson.duration_hour
      this.timeSettingDialogVisible = true
    },
    copyToClip(content) {
      content = content.replace(/\n/g, '  ')
      var aux = document.createElement("input");
      aux.setAttribute("value", content);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      this.$message.success("已复制到剪切板！")
    },
    getBrText(text) {
      if (text) {
        return text.replace(/\n/g, '<br>')
      }
      return ""
    },
    noticeTeacherProvideInfo(lesson) {
      notice_teacher_provide_info(lesson, this)
    },
    orderTimeComfirm(lesson) {
      this.confirm_lesson_info = lesson
      this.orderTimeDialogVisible = true
    },
    checkLessonInfo(lesson) {
      this.check_lesson_info = lesson
      this.lessonInfoDialogVisible = true
    },
    confirmLessonTime(id) {
      confirm_lesson_time(id, this)
    },
    disconfirmLessonTime(id) {
      deconfirm_lesson_time(id, this)
    },
    payForSingleLesson(id) {
      get_single_lesson_payment_url(id, this)
    },
    handleSelect(key) {
      if (key === "tutorial") {
        this.tutorialDisplayDialogVisible = true
      }
      else if (key !== "kc") {
        this.display_index = key
      } else {
        download_user_ics(this)
      }
    },
    getDisplayDate(time) {
      let time_obj = new Date(time)
      return time_obj.toLocaleString()
    },
    goToTeacherDetail(id) {
      let new_id = crypto_utils.encrypt(randomString(8) + id.toString())
      // this.$router.push("/discover?id=" + new_id,)
      let routeUrl = this.$router.resolve({
        path: "/discover",
        query: {id: new_id}
      });
      window.open(routeUrl.href, '_blank');
    },
    changePass() {
      this.$router.push({path: '/user/change_pass/', params: {user: this.user.username}})
    },
    getDisplayStatus(status) {
      if (status === "waiting") {
        return "等待上课"
      } else if (status === "ordering") {
        return "约课待确认"
      } else if (status === "finished") {
        return "已结课"
      } else if (status === "reorder") {
        return "重新约课中"
      } else if (status === "error") {
        return "异常未完成"
      } else if (status === "return") {
        return "已退款"
      } else {
        return "未知"
      }
    },
    tableRowClassName({row, rowIndex}) {
      if (row.has_finished && this.display_index === "lesson_finished") {
        return 'show';
      } else {
        return 'hide';
      }
    }
  }
}
</script>

<style scoped>
.show {

}

.hide {
  display: none;
}

.user_info .label {
  padding: 10px;
  color: #111111;
  font-weight: bold;
  font-size: 16px;
}

.user_info .label .content {
  margin-left: 5px;
  color: dimgray;
  font-size: 14px;
}
</style>